import { render, staticRenderFns } from "./xtypeHeader.vue?vue&type=template&id=5a821e86&scoped=true&"
import script from "./xtypeHeader.vue?vue&type=script&lang=js&"
export * from "./xtypeHeader.vue?vue&type=script&lang=js&"
import style0 from "./xtypeHeader.vue?vue&type=style&index=0&id=5a821e86&scoped=true&lang=css&"
import style1 from "./xtypeHeader.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a821e86",
  null
  
)

component.options.__file = "xtypeHeader.vue"
export default component.exports